import React from 'react'
import {Navigation} from '../components/Navigation'
import {Placeholder, Label, Table, Button, Icon, Card, Transition, Loader} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
//import {Schedule} from '../components/schedule/schedule.js'
//import {default as EventPicker} from '../components/eventpicker/picker.js';
import {Route} from '../components/Router.js'
//import * as MarketingdisplaysActions from '../actions/MarketingdisplaysActions.js';
import {default as Eventticker} from '../components/bookmaker/eventticker';

export default function Bookmaker() {
  return (
    <Eventticker />
  )
}